<template>
    <card class="card-pricing bg-gradient-default border-0 text-center mb-4"
        header-classes="bg-transparent"
        body-classes="px-lg-7"
        footer-classes="bg-transparent"
        v-if="session">

        <div class="display-3 text-white mb-3">
            <span class="text-muted d-inline">{{ session.cohort.name }}</span>
            <span class="text-muted d-inline"> / {{ session.degree.name }}</span>
            <span class="d-inline" v-if="session.simulation">
                <span class="d-inline text-muted">/</span>
                <span class="d-inline">{{ simulationName(session) }}</span>
            </span>
        </div>
    
        <div class="d-flex flex-row justify-content-center pb-4" v-if="session.mode == 'resit' || session.scheduled_at">
            <div class="mx-4" v-if="session.mode == 'resit'">
                <span class="icon icon-xs icon-shape bg-white shadow rounded-circle">
                    <i class="fas fa-undo"></i>
                </span>
                <span class="pl-1 text-sm text-white">
                    {{ $t('sessions.resit') }}
                </span>
            </div>
            <div class="mx-4" v-if="session.scheduled_at">
                <span class="icon icon-xs icon-shape bg-white shadow rounded-circle">
                    <i class="fas fa-calendar-alt"></i>
                </span>
                <span class="pl-1 text-sm text-white">
                    {{ scheduledAt }}
                </span>
            </div>
            <div class="mx-4">
                <badge :type="statusColor(session.status)">{{ statusLabel(session.status) }}</badge>
            </div>
        </div>

        <div class="d-flex flex-row justify-content-center pb-2">
            <div class="mx-5">
                <div class="avatar rounded-circle">
                    <img alt="Image placeholder" :src="session.learner.avatar">
                </div>
                <h4 class="text-white mb-0">
                    {{ session.learner.name }}
                </h4>
                <small class="text-muted position">
                    {{ $t('common.learner') }}
                </small>
            </div>
            <div class="mx-5" v-if="session.tester1">
                <div class="avatar rounded-circle">
                    <img alt="Image placeholder" :src="session.tester1.avatar">
                </div>
                <h4 class="text-white mb-0">
                    {{ session.tester1.name }}
                </h4>
                <small class="text-muted position">
                    {{ $t('common.tester') }}
                </small>
            </div>
            <div class="mx-5" v-if="session.tester2">
                <div class="avatar rounded-circle">
                    <img alt="Image placeholder" :src="session.tester2.avatar">
                </div>
                <h4 class="text-white mb-0">
                    {{ session.tester2.name }}
                </h4>
                <small class="text-muted position">
                    {{ $t('common.tester') }}
                </small>
            </div>
        </div>

        <div class="mt-4 mb-2" v-if="session && session.sync">
            <span :class="'sync-notice bg-' + session.sync.color">
                <strong>{{ $t('pwa.offline-mode') }}:</strong> {{ $t('pwa.local-notice-' + session.sync.color) }}
            </span>
        </div>
    </card>
</template>

<script>
    import moment from 'moment'

    export default {

        props: {
            session: {
                type: Object,
                required: true
            },

            statusData: {
                type: Array,
                required: true
            },

            statusColors: {
                type: Object,
                required: true
            },
        },

        data() {
            return {
                moment: moment,
            }
        },

        computed: {

            scheduledAt() {
                return this.moment(this.session.scheduled_at).format('YYYY/MM/DD HH:mm')
            },
        },

        methods: {
                       
            simulationName(session) {
                let role = session.simulation.use_simulation_role2 && session.degree.simulation_role_2
                    ? session.degree.simulation_role_2_name[session.degree.lang]
                    : session.degree.simulation_role_1_name[session.degree.lang]

                return session.simulation.name + ' (' + role + ')'
            },

            statusColor(status) {
                return this.statusColors[status]
            },

            statusLabel(status) {
                return this.statusData.find(item => item.id == status).name
            },
        }
    }
</script>

<style lang="css" scoped>

    .status-items {
        gap: 10px;
    }
    .sync-notice {
        color: #ffffff;
        padding: .2rem .6rem;
        border-radius: .375rem;
        font-size: 0.8rem;
    }
    .bg-success {
        background-color: #22a069 !important;
    }

</style>